import HubspotForm from "react-hubspot-form";
import NextLink from "next/link";
import {Flex, Stack, Text} from "@chakra-ui/react";
import Button from "../../components/Button";
import {Container} from "../../components/Container";
import Heading from "../../components/Heading";

const ContactUs = ({emailText}: {emailText: React.ReactNode}) => (
  <Container pb={[28, 32]} pt={[20, 32]}>
    <Flex maxW="full" flexWrap="wrap" gap={20}>
      <Stack flex={1} minW={["full", "full", "full", 1]} gap={8}>
        <Heading>Book a demo</Heading>
        <HubspotForm portalId="143180593" formId="ea9030dc-5220-4e85-b911-8108f88c01bf" region="eu1" />
      </Stack>
      <Stack flex={1} minW={["full", "full", 1]} gap={10}>
        <Heading>Get in touch</Heading>
        <Text fontSize="lg" color="gray.600">
          {emailText}
        </Text>
        <Flex>
          <Button
            as={NextLink}
            href="mailto:hello@platformed.com?subject=Let's talk about Platformed"
            colorPalette="blue"
            size="lg"
            px={24}
          >
            Email us
          </Button>
        </Flex>
      </Stack>
    </Flex>
  </Container>
);

export default ContactUs;
